import React from 'react';
import { Monitor } from 'lucide-react';

interface Props {
  isOpen: boolean;
  eventCount: number;
  onClick: () => void;
}

export function GlassBoxToggle({ isOpen, eventCount, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      title={`${isOpen ? 'Hide' : 'Show'} Glass Box (Cmd+Shift+D)`}
      className={`relative flex items-center gap-1.5 px-2 py-1 rounded text-sm transition-colors ${
        isOpen
          ? 'bg-primary-500/15 text-primary-400 border border-primary-500/30'
          : 'text-text-secondary hover:text-text-primary hover:bg-surface-800'
      }`}
    >
      <Monitor className="w-3.5 h-3.5" />
      <span className="hidden sm:inline">Glass Box</span>
      {eventCount > 0 && (
        <span
          className={`text-[9px] font-medium px-1 rounded-full min-w-[14px] text-center ${
            isOpen
              ? 'bg-primary-500/30 text-primary-300'
              : 'bg-surface-700 text-text-muted'
          }`}
        >
          {eventCount > 999 ? '999+' : eventCount}
        </span>
      )}
    </button>
  );
}
